import React from "react";
import { Table, Card, Alert } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useCompliance from "Hooks/EmployeeHooks/useCompliance";

const Compliance = () => {
  const { allCompliances, loading, columns, DetailsModal, ConfirmModal } = useCompliance();

  const pendingCount = allCompliances.filter((item) => !item.isAcknowledged).length;
  const acknowledgeCount = allCompliances.filter((item) => item.isAcknowledged).length;

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card
            title={
              <div className="d-flex align-items-center">
                <span>My Compliance Policies</span>
              </div>
            }
            className="card-professional"
          >
            {/* Status Alert */}

            <Alert
              message={`You have ${pendingCount} pending policy${
                pendingCount > 1 ? "s" : ""
              } to acknowledge and ${acknowledgeCount} acknowledged policy${
                acknowledgeCount > 1 ? "s" : ""
              }`}
              type="success"
              showIcon
              style={{ marginBottom: 16 }}
            />

            {/* Policies Table */}
            <Table
              className="custom-table"
              dataSource={allCompliances}
              columns={columns}
              rowKey="id"
              loading={loading}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} policies`,
              }}
              locale={{
                emptyText: (
                  <div style={{ padding: "40px 0", textAlign: "center" }}>
                    <CheckCircleOutlined style={{ fontSize: "48px", marginBottom: "16px" }} />
                    <div style={{ fontSize: "16px", color: "#8c8c8c" }}>
                      No pending compliance policies
                    </div>
                    <div style={{ fontSize: "14px", color: "#bfbfbf", marginTop: "8px" }}>
                      All policies have been acknowledged
                    </div>
                  </div>
                ),
              }}
            />
          </Card>

          {/* Modals */}
          <DetailsModal />
          <ConfirmModal />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Compliance;
